import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';
import {
    DatiqMenuType,
    IDatiqMenu,
    IDatiqMenuItem
} from './models';
import { DatiqMenuEventsService } from './services';

@Component({
    selector: 'datiq-menu',
    templateUrl: './datiq-menu.component.html',
    styleUrls: ['./datiq-menu.component.scss'],
})
export class DatiqMenuComponent {
    @Input()
    settings: IDatiqMenu;
    @Output()
    menuItemClicked: EventEmitter<IDatiqMenuItem> = new EventEmitter<IDatiqMenuItem>();

    public menuTypes = {
        button: DatiqMenuType.Button,
        icon: DatiqMenuType.Icon,
    };

    constructor(private _events: DatiqMenuEventsService) {}

    clickedMenuItem(menuItem: IDatiqMenuItem): void {
        this.menuItemClicked.emit(menuItem);
        this._events.clickMenuItem(menuItem, this.settings);
    }

    clickTrigger(): void {
        this._events.clickMenuTrigger(this.settings);
    }
}
